import { differenceInMonths } from 'date-fns';
import { ICustomerDataSheetInvoice } from '../common/interfaces/customers.interface';

export default class DatasheetHelper {
  public static calculateAverageMonthlyOrders(invoices: ICustomerDataSheetInvoice[]): number {
    const months = DatasheetHelper.getMonthsForOrderAverages(invoices);
    return invoices.length / (months || 1);
  }

  public static calculateAverageMonthlyOrderValue(invoices: ICustomerDataSheetInvoice[]): number {
    const months = DatasheetHelper.getMonthsForOrderAverages(invoices);
    const overallTotal = Math.round(invoices.reduce((a, b) => a + b.total, 0) * 100) / 100;
    return overallTotal / (months || 1);
  }

  private static getMonthsForOrderAverages(invoices: ICustomerDataSheetInvoice[]): number | false {
    if(invoices.length < 1) {
      return false;
    }

    const earliestDateString = invoices[invoices.length - 1].date;

    if(!earliestDateString) {
      return false;
    }

    const earliestDateParts = earliestDateString.substr(0, 10).split(`.`).map(part => +part);
    const earliestDate = new Date(earliestDateParts[2], earliestDateParts[1] - 1, earliestDateParts[0]);
    return differenceInMonths(new Date(), earliestDate);
  }
}
